module.exports = __webpack_public_path__ + "static/img/Royce-Simmons.76f5952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Royce-Simmons.jpg
// module id = roie
// module chunks = 0